module.exports = __webpack_public_path__ + "static/img/image_we_09_01.074ead4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_09_01.png
// module id = AfSf
// module chunks = 10